<p style="position:sticky;top:0;z-index:10">
    <mat-toolbar  class="toolbarClass">
      <button mat-icon-button *ngIf="!sidenavToggleState"
      (click)="toggleSidenav()"
      class="example-icon"
       aria-label="Example icon-button with menu icon">
        <mat-icon>menu</mat-icon>
      </button>
      <!-- <span>Beato</span> -->
      <!-- <span class="example-spacer"></span>
      <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>favorite</mat-icon>
      </button>
      <button mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">
        <mat-icon>share</mat-icon>
      </button> -->
    </mat-toolbar>
  </p>